module.exports = __webpack_public_path__ + "img/qy (34).9f706356.jpg";